module.exports = __webpack_public_path__ + "img/wellness.b43e2899.jpg";